import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@mui/material';
import { t } from '../../translations/i18n';
import MikeButton from '../../shared-components/mike-button';

type ConfirmGeometryMultipleDeleteDialogProps = {
  open: boolean;
  onClose: (confirmed: boolean) => void;
};

/**
 * Shows a confimation dialog for deleting multiple geometries and notifies a parent component of deletion through a callback.
 *
 * @param props
 */
export const MmgConfirmGeometryMultipleDeleteDialog = (props: ConfirmGeometryMultipleDeleteDialogProps) => {
  const { open, onClose } = props;

  const handleClose = () => {
    onClose(false);
  };

  const handleOk = () => {
    closeDialog(true);
  };

  const handleCancel = () => {
    closeDialog(false);
  };

  const closeDialog = (confirmed: boolean) => {
    onClose(confirmed);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      id="confirm-delete-geometry"
      aria-labelledby="delete-geometry-dialog-title"
      aria-describedby="delete-geometry-dialog-description"
    >
      <DialogTitle id="delete-geometry-dialog-title">
        {t('GEOMETRY_CONFIRM_DELETE_TITLE', 2)}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="delete-geometry-dialog-description">
          {t('GEOMETRY_CONFIRM_DELETE_TEXT', 2)}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <MikeButton onClick={handleCancel} variant="outlined" color="secondary">
          {t('CANCEL')}
        </MikeButton>
        <MikeButton onClick={handleOk} variant="contained" color="secondary" autoFocus>
          {t('DELETE')}
        </MikeButton>
      </DialogActions>
    </Dialog>
  );
};
